import React from 'react';
import { Header, Segment, Icon, Button, Image } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import AppHelmet from 'app/components/AppHelmet';
import ApiCalls from 'app/utils/apiCalls';

export class DownloadPage extends React.PureComponent {
  render() {
    const { intl } = this.props;
    return (
      <div style={{ marginBottom: '75px' }}>
        <AppHelmet titleIntlID="download.pageTitle" descriptionIntlID="download.pageDescription" />
        <div className="ui container" style={{ paddingTop: '20px' }}>
          <h1 style={{ fontSize: '2.7em', textAlign: 'center', marginBottom: '35px' }}>
            <FormattedMessage id="download.title" />
          </h1>
          <Segment as="section" style={{ textAlign: 'center', marginBottom: '35px' }}>
            <Header icon>
              <Image src="/icon.png" style={{ width: '6.5em' }} alt="Logo PicoxIA" />
              <p>
                <FormattedMessage id="download.startNow" />
              </p>
            </Header>
            <br />
            <Button
              href={`${ApiCalls.getBackendRoute()}/download_update?app_name=picoxia_ia`}
              className="green"
            >
              <Icon name="windows" />
              <FormattedMessage id="download.windows" />
            </Button>
          </Segment>

          <section>
            <Header as="h2" dividing>
              <FormattedMessage id="download.features" />
            </Header>
            <Header as="h3" dividing>
              <Icon name="cut" />
              <FormattedMessage id="download.features.snipper" />
            </Header>
            <p>
              <FormattedMessage id="download.features.snipper.description" />
            </p>
            <div style={{ textAlign: 'center' }}>
              <iframe
                src={`https://www.youtube.com/embed/${intl.formatMessage({
                  id: 'download.features.snipper.video.id',
                })}?rel=0&amp;loop=1`}
                title={intl.formatMessage({ id: 'download.features.snipper.video.title' })}
                width="720"
                height="450"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
            <Header as="h3" dividing>
              <Icon name="paper plane" />
              <FormattedMessage id="download.features.export" />
            </Header>
            <p>
              <FormattedMessage id="download.features.export.description" />
            </p>
          </section>
        </div>
      </div>
    );
  }
}

export default injectIntl(DownloadPage);
